import { useState, useEffect } from 'react';

import { SeamPattern } from '../model/seam-pattern';
import { SeamRequest } from '../model/seam-request';
import { seamPatternService } from '../services/seam-pattern.service';

interface UseOpposingPatternsReturn {
    patterns: SeamPattern[];
    isLoading: boolean;
    error: string;
}

export const useOpposingPatterns = (seamRequest: SeamRequest): UseOpposingPatternsReturn => {
    const [patterns, setPatterns] = useState<SeamPattern[]>([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        setIsLoading(true);
        setError('');
        const queryFilters = { opposing: 'true' };

        const subscription = seamPatternService.listAll({ queryFilters }, seamRequest).subscribe({
            next: (data) => {
                setPatterns(data);
                setIsLoading(false);
            },
            error: () => {
                setIsLoading(false);
            },
        });

        return () => {
            subscription.unsubscribe();
        };
    }, [seamRequest]);

    return { patterns, isLoading, error };
};
